module.exports = "https://web-assets.ifttt.com/packs/media/perks/setup-6f5c7335.svg";